import { createAsyncThunk } from '@reduxjs/toolkit';
import { getFeed } from '../../../api/feeds';
import { createRequest } from '../../../helpers/api/createRequest';

export const GET_FEED = 'feeds/getFeed';

export const getFeedThunk = createAsyncThunk(
    GET_FEED,
    createRequest({
        type: GET_FEED,
        loader: async (id: number) => getFeed(id),
    }),
);
